import { Box, Grid, styled, Typography } from '@mui/material'
import React from 'react'
import { Fade } from 'react-reveal'

const Component=styled(Box)`
    display:flex;
    justify-content:center;
    align-items:center;
`

const Skill=styled(Box)`
    width:80%;
    background:#f6f6f6;
    height:192px;
    margin:28px;
    display:flex;
    justify-content:center;
    align-items:center;
    flex-direction:column;
    box-shadow: -12px -12px 25px white, 12px 12px 25px rgb(165 181 248 / 40%);
    transition: 1s;
    &:hover{
      transform:scale(1.3);
    }
`

const Skills = () => {
  return (
    <Box style={{marginTop:'78px',width:'100%'}} id="Skill">
      <Fade right big>
        <h1 style={{color:'#010B30',marginLeft:'53px'}}>Skills :</h1>
        <Component>
          <Grid container>
            <Grid items lg={4} md={6} sm={12} style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
      <Skill><h3 style={{color:'#0b2593',textAlign:'center'}}>Web Designing</h3>
        <Typography style={{textAlign:'center',marginTop:'10px',color:'#646464',overflow:'hidden'}}>I love designs and it's the first step before creating any website as I can give layout to my imagination.</Typography>
      </Skill>
      </Grid>
      <Grid items lg={4} md={6} sm={12} style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
      <Skill><h3 style={{color:'#0b2593',textAlign:'center'}}>Full Stack Web Development</h3>
        <Typography style={{textAlign:'center',marginTop:'10px',color:'#646464'}}>I am a Full Stack Web Developer (MERN) and have quite some experience in it as well.</Typography>
      </Skill>
      </Grid>
      <Grid items lg={4} md={6} sm={12} style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
      <Skill><h3 style={{color:'#0b2593',textAlign:'center'}}>Problem Solving Skills</h3>
        <Typography style={{textAlign:'center',marginTop:'10px',color:'#646464'}}>I love solving problems whether programming problems or real life problems.</Typography>
      </Skill>
      </Grid>
      </Grid>
      </Component>
      <Box style={{textAlign:'center',width:'100%',fontFamily:"'Lora', serif"}}>
      <h2 style={{textAlign:'center',color:'#646464'}}>Tech I am Familiar with :</h2><hr style={{width:'10rem'}}></hr>
      <Box style={{display:'flex'}}>
      <Box style={{width:'50%',textAlign:'center'}}>
        
            <ul style={{listStyle:'none',fontFamily:"'Lora', serif"}}>
            <h3>Frontend</h3><hr style={{width:'4rem'}}/>
                <li>HTML5</li>
                <li>CSS3</li>
                <li>JAVASCRIPT</li>
                <li>REACT JS</li>
                <li>BOOTSTRAP</li>
                <li>MATERIAL UI</li>
            </ul>
      </Box>
      <Box style={{width:'50%',textAlign:'center'}}>
        <ul style={{listStyle:'none',fontFamily:"'Lora', serif"}}>
        <h3>BACKEND</h3><hr style={{width:'4rem'}}/>
            <li>MONGO DB</li>
            <li>EXPRESS JS</li>
            <li>NODE JS</li>
            <li>MONGOOSE</li>
        </ul>
      </Box>
      </Box>
      </Box>
      </Fade>
    </Box>
  )
}

export default Skills
